// extracted by mini-css-extract-plugin
module.exports = {"modalDialog":"Modal_modalDialog__aKeyN","modalContent":"Modal_modalContent__KbNyp"};